<template>
  <div class="">
    <ul v-if="selectedMembershipGroups.length > 0">
      <li
        v-for="group in selectedMembershipGroups"
        :key="group.uuid"
        v-text="group.attributes.title"
      />
    </ul>
    <span
      v-else
      class="text-xs italic"
      v-text="'None'"
    />
  </div>
</template>

<script type="text/babel">
export default {
  name: 'MembershipGroupList',
  props: {
    selectedMembershipGroups: {
      type: Array,
      required: true,
    },
  },
}
</script>
